export const validationSectionsValidation = {
  user: ["phone", "email", "ssn", "gender", "headline", "hsa"] as const,
  languages: "languages",
  specialities: "specialities",
  descriptions: "descriptions",
  comments: "comments",
  gender: "gender",
  absenceStatus: "absenceStatus",
  employmentType: "employmentType",
} as const;

export type ValidationKeys = keyof typeof validationSectionsValidation;
export type UserValidationKeys =
  (typeof validationSectionsValidation.user)[number];

export type PsychologistValidationKeys =
  | Exclude<ValidationKeys, "user">
  | UserValidationKeys;
